import "./Major.css"
import major from '../images/major.png';

export default function Major() {
    return (
        <div className="major-container">
            <img src={major} />
        </div>
    );
}